/**
 * Búsqueda del selector de clientes del modo comercial: por razón social, alias (el "Alias" de la
 * ficha de BC), número de cliente y CIF; sin distinguir mayúsculas ni acentos y por palabras sueltas
 * ("vet astorga" encuentra "CLIN. VET. ASTORGA").
 */
export const normalizar = (texto) =>
  (texto || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const textoBuscable = (c) =>
  normalizar([c.numCliente, c.nombreRazonSocial, c.alias, c.cifNiff].filter(Boolean).join(' '));

export const filtrarClientes = (opciones, { inputValue }) => {
  const palabras = normalizar(inputValue).split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return opciones;
  return opciones.filter(c => {
    const texto = textoBuscable(c);
    return palabras.every(p => texto.includes(p));
  });
};

export const etiquetaCliente = (c) =>
  `${c.numCliente} — ${c.nombreRazonSocial}${c.alias ? ` · ${c.alias}` : ''}`;
